import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { JobInviteControl, ScheduleLinkControl } from './Controls'

export const CardActionBar = ({
  config = {},
  candidate = {},
  jobInviteControlProps,
  scheduleLinkControlProps,
  ...props
}) => {
  const { t } = useTranslation()

  return (
    <div className={'d-flex gap-2'}>
      {config.jobInvite && <JobInviteControl candidate={candidate} {...jobInviteControlProps} />}

      {config.scheduleLink && candidate?.student_profile?.schedule_link && (
        <ScheduleLinkControl candidate={candidate} {...scheduleLinkControlProps} />
      )}
    </div>
  )
}

CardActionBar.propTypes = {
  config: PropTypes.object,
  candidate: PropTypes.object,
  jobInviteControlProps: PropTypes.object,
  scheduleLinkControlProps: PropTypes.object,
}
